import { Flex, List } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { IReportIssueProps } from '@common/types/types';
import { getLocalizedDateTime } from '@common/helpers/getCurrentDateAndTime';
import { getConcatIssueLabels } from '@common/helpers/getConcatIssueLabels';
import { ActionBlock } from 'src/components';
import { SiteInfoBlock, StatusBlock, UserInfoBlock } from '@common/components';

import styles from './styles.module.scss';
import { useAppSelector } from 'src/store';
import { IAdminIssue } from 'src/store';
import { useMediaQuery } from '@mantine/hooks';

interface Props {
  item: IReportIssueProps | IAdminIssue;
  userRole: string;
}

const ReportedItem: FC<Props> = ({ item, userRole }) => {
  const [t] = useTranslation('reported');
  const concatenatedLabels = getConcatIssueLabels(item.type);
  const { paymentPlan } = useAppSelector((state) => state.payment.data);
  const isMediumDevice = useMediaQuery('(max-width: 992px)');
  const isXLargeDevice = useMediaQuery('(max-width: 1408px)');

  return (
    <List.Item className={styles['list-item']} key={item.reportNumber}>
      <h2 className={styles.date}>
        {t('report')} {item.reportNumber} {t('for')} {getLocalizedDateTime(new Date(item.createdDate))}
      </h2>
      <Flex
        wrap={isXLargeDevice ? 'nowrap' : 'wrap'}
        justify={'space-between'}
        direction={isMediumDevice ? 'column' : 'row'}>
        <Flex w={isMediumDevice ? 'auto' : 500} direction={isMediumDevice ? 'column' : 'row'} gap={16}>
          <SiteInfoBlock reportNumber={item.reportNumber} image={item.screenshotUrl} site={item.fullUrl} />
          <UserInfoBlock
            id={item.userId}
            issue={concatenatedLabels}
            browser={item.browser}
            settings={item.widgetSettings}
          />
        </Flex>
        <StatusBlock status={item.status} archived={item.archived} />
        <ActionBlock item={item} userRole={userRole} locked={['free', 'free plan'].includes(paymentPlan)} />
      </Flex>
    </List.Item>
  );
};

export default ReportedItem;
